<template>
  <el-dialog
    title="Seleccione los prodcuctos de la lista"
    width="60%"
    :close-on-click-modal="false"
    :before-close="modalProductClose"
    :visible.sync="modalProductOpen"
    :top="'5vh'"
  >
    <el-row :gutter="10">
      <el-col :span="7">
        <el-input size="small" placeholder="Digite el Código" v-model="code" clearable></el-input>
      </el-col>
      <el-col :span="6">
        <el-input size="small" placeholder="Digite el #Referencia" v-model="reference" clearable></el-input>
      </el-col>
      <el-col :span="7">
        <el-input size="small" placeholder="Digite la descripción" v-model="description" clearable></el-input>
      </el-col>
      <el-col :span="4">
        <el-button
          size="small"
          type="primary"
          icon="el-icon-search"
          :loading="loadingFilter"
          @click="filterProduct"
        >Filtrar</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" class="row-table">
        <el-table
          style="width: 100%"
          height="400"
          ref="multipleTable"
          v-loading="loadingTable"
          element-loading-text="Cargando datos..."
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgb(246 246 246 / 80%)"
          :data="tableData"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column label="Código" prop="product.codigo" width="150"></el-table-column>
          <el-table-column label="Referencia" prop="product.referencia"></el-table-column>
          <el-table-column label="Descripcion" prop="product.descripcion"></el-table-column>
          <el-table-column label="Categoria" prop="product.category.descripcion"></el-table-column>
          <el-table-column label="Saldo" prop="saldo"></el-table-column>
          <el-table-column label="Precio" width="100">
            <template slot-scope="props">
              <label class="price">$ {{formatNumber(props.row.product.precio_venta, true)}}</label>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <span slot="footer" class="dialog-footer">
      <el-button icon="el-icon-close" @click="modalProductClose">Cancelar</el-button>
      <el-button type="success" icon="el-icon-plus" @click="addToDetail">Agregar a la lista</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {
  roundToTheNearestAnything,
  formatNumber,
  formatInt,
} from "@/utils/number";
import { searchProduct } from "@/api/pos";
export default {
  name: "Product",
  props: ["modalProductOpen", "branch"],
  data() {
    return {
      loadingFilter: false,
      loadingTable: false,
      code: "",
      reference: "",
      description: "",
      tableData: [],
      multipleSelection: [],
    };
  },
  methods: {
    modalProductClose() {
      this.$emit("close");
    },
    filterProduct() {
      // code, reference, description, branch_id, transaction, type_id
      let me = this;
      this.loadingFilter = true;
      me.loadingTable = true;
      var data = {
        code: this.code,
        reference: this.reference,
        description: this.description,
        branch_id: this.branch.id,
        transaction: 2,
        type_id: 1,
      };
      searchProduct(data)
        .then(({ data }) => {
          me.loadingFilter = false;
          me.loadingTable = false;
          if ((data.code = 200)) {
            this.tableData = data.data;
          } else {
            this.$message.error("Oops, Error.");
            console.log(data.data.error);
          }
        })
        .catch((error) => {
          me.loadingFilter = false;
          me.loadingTable = false;
          this.$message.error("Oops, Error al registrar.");
          console.log(error);
        });
    },
    addToDetail(){
      if (this.multipleSelection.length > 0) {
        this.$emit('addProducts', this.multipleSelection);
        this.modalProductClose()
      }else{
        this.$message('Selecciona algun producto');
      }
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    formatNumber(number, round) {
      //PASAR INTEGER A FORMATO NUMERO
      var num = formatNumber(number);
      if (typeof round != "undefined") {
        // REDONDEO Y QUITO LOS DECIMALES
        num = formatNumber(Math.trunc(number));
      }
      return num;
    },
  },
};
</script>
<style lang="css">
.row-table {
  margin-top: 20px;
}
</style>